import type { TariffWithVerificationValues } from '@src/stores/product';

export const getVerificationValue = (
  tariffWithVerificationValues: TariffWithVerificationValues[],
  tariffTypeId: string,
  verificationId: string,
  tariffUnitIndex: number,
  verificationPosition: number,
): string =>
  tariffWithVerificationValues
    .find((v) => v.tariffTypeId === tariffTypeId)
    ?.verificationValues?.find(
      (v) =>
        v.tariffVerificationId === verificationId &&
        v.tariffUnitIndex === tariffUnitIndex &&
        v.verificationPosition === verificationPosition,
    )?.value || '';
